import { useQuery } from "@tanstack/react-query";
import { TicketProvisioningJobStatusDetails } from "features/types";
import { get } from "services/http";

export const useFetchMyInProgressTicketProvisioningJobsQuery = () => {
  return useQuery(
    ["ticketProvisioning", "my", "in-progress"],
    async () =>
      (await get({
        url: "/ticket-provisioning/my/in-progress",
      })) as TicketProvisioningJobStatusDetails[],
    {
      staleTime: 1000 * 15,
      refetchInterval: (data) => {
        if (!data || data.length === 0) return false;
        return 1000 * 10;
      },
    }
  );
};
